import BloodPressureTable from './BloodPressureTable'

export default BloodPressureTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/BloodPressureTable/index.js